// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Tgfat","title":"styles_title__1nhPj"};